const updates = [
  { date: '07-30', title: '《长安十二时辰》第二季全集上线', tag: '新剧上线', tagColor: 'bg-primary-100 text-primary-700' },
  { date: '07-29', title: '樱桃视频热门综艺《奔跑吧》最新期已同步', tag: '综艺更新', tagColor: 'bg-accent-100 text-accent-700' },
  { date: '07-28', title: '糖心视频独家短剧《微光城市》系列上线', tag: '独家内容', tagColor: 'bg-secondary-100 text-secondary-700' },
  { date: '07-27', title: '红桃视频高分电影《流浪地球3》高清上线', tag: '电影上新', tagColor: 'bg-primary-100 text-primary-700' },
  { date: '07-26', title: '茄子视频七月新番动漫专题页面上线', tag: '动漫专题', tagColor: 'bg-accent-100 text-accent-700' },
  { date: '07-25', title: '本站服务器全面升级，播放体验大幅提升', tag: '平台公告', tagColor: 'bg-secondary-100 text-secondary-700' },
  { date: '07-24', title: '桃子视频热门脱口秀《吐槽大会》最新季上线', tag: '综艺上新', tagColor: 'bg-primary-100 text-primary-700' },
  { date: '07-23', title: '全网电视剧热度榜更新，多部新剧上榜', tag: '榜单更新', tagColor: 'bg-accent-100 text-accent-700' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-[900px] mx-auto">
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 text-center mb-2">最新动态</h2>
        <p className="text-sm text-foreground-400 text-center mb-8 md:mb-10">影视资源每日更新，快讯实时同步</p>
        <div className="relative">
          <div className="absolute left-[19px] top-2 bottom-2 w-px bg-background-300 hidden sm:block"></div>
          <div className="flex flex-col gap-4">
            {updates.map((item, idx) => (
              <div key={idx} className="flex items-start gap-4">
                <div className="hidden sm:flex flex-shrink-0 w-[38px] h-[38px] rounded-full bg-background-100 border-2 border-background-300 items-center justify-center relative z-10">
                  <span className="w-2 h-2 rounded-full bg-primary-500"></span>
                </div>
                <div className="flex-1 bg-background-100 rounded-lg p-4 md:p-5 flex flex-col sm:flex-row sm:items-center gap-3">
                  <span className="text-xs font-medium text-foreground-400 whitespace-nowrap">{item.date}</span>
                  <p className="text-sm text-foreground-800 flex-1">{item.title}</p>
                  <span className={`text-xs font-medium px-2.5 py-1 rounded-full whitespace-nowrap self-start ${item.tagColor}`}>
                    {item.tag}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}